<template>
    <div class="newsList">
        <div class="newsItemsBox">
            <div class="newsItems" v-for="(item, index) in list" :key="index" @click="jump(item)">
                <img class="itemImg" :src="item.litpic" />
                <div class="item-right">
                    <div class="line-warp">
                        <div class="yuan"></div>
                        <div class="line"></div>
                    </div>
                    <div class="title">{{ item.title }}</div>
                    <p class="newsItemsContent">{{ item.seo_description }} </p>
                    <p class="time">{{ item.add_time }} </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {

        }
    },
    props: {
        list: {
            type: Array,
            default() {
                return []
            }
        }
    },
    methods: {
        jump(item) {
            // this.$router.push({path:'/NewsDetail'})
            // let routeData = this.$router.resolve({
            //     path: "/NewsDetail",
            //         query: {id:item.id}
            // });
            // window.open(routeData.href, '_blank');

            this.$emit('jump', item)

        }
    }
}
</script>

<style lang="scss" scoped>
.newsList {
    .newsItemsBox {
        width: 1200px;
        margin: 0 auto;

        .newsItems {
            margin-bottom: 90px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;

            .itemImg {
                width: 367px;
                height: 245px;
                object-fit: cover;
                border-radius: 12px;
            }

            .item-right {
                width: 580px;

                .title {
                    font-size: 24px;
                    font-weight: bolder;
                    margin-bottom: 20px;
                    text-align: left;
                }

                .line-warp {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    .yuan {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background-color: rgb(5, 16, 254);
                    }

                    .line {
                        width: calc(100% - 20px);
                        height: 1px;
                        background: rgb(172, 172, 172);
                    }
                }

                .newsItemsContent {
                    font-size: 16px;
                    color: rgb(71, 71, 71);
                    margin-bottom: 20px;
                }

                .time {
                    font-size: 20px;
                    color: #000;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>